export enum ProductType {
  AsphaltCutters = "asphaltcutters",
  AttachmentFramesTools = "attachmentframestools",
  Buckets = "buckets",
  Compactors = "compactors",
  ControlSystems = "controlsystems",
  GradingBeams = "gradingbeams",
  GrappleModules = "grapplemodules",
  Grapples = "grapples",
  LowerBrackets = "lowerbrackets",
  MachineFixings = "machinefixings",
  RailGrapples = "railgrapples",
  Rippers = "rippers",
  Rototilts = "rototilts",
  Supplements = "supplements",
  UpperBrackets = "upperbrackets",
}
